import React from "react"
import { Menu, useResourceDefinitions, useSidebarState } from "react-admin"
import {
    Box,
    Select,
    MenuItem,
    SelectChangeEvent,
    FormControl,
    InputLabel,
    ListItemIcon,
    Tooltip,
  } from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import AdminIcon from "@mui/icons-material/AdminPanelSettings"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import Sensors from '@mui/icons-material/Sensors'
import AccountTreeIcon from "@mui/icons-material/AccountTree"
import MapIcon from "@mui/icons-material/MapSharp"
import { useTranslate } from "ra-core"
import { useStore } from "react-admin"
import { UserProps, UserProfileTypeEntity } from "store.context"
import { default as ReferenceBooksItem } from "./reference.books"
import { ScreenEmpty } from "components/ui/screen"


const MainMenu = (props: {onProfileChange(p: UserProfileTypeEntity): void}) => {
    const { onProfileChange } = props
    const resources = useResourceDefinitions()
    const translate = useTranslate()
    const [ user ] = useStore<UserProps>('currentUser', undefined)
    const [ profile ] = useStore<UserProfileTypeEntity>('currentProfile', undefined)
    const [ menuOpen ] = useSidebarState()

    const handleUpdateProfile = (event: SelectChangeEvent) => {
        if (user?.profiles) {
            const prof = user.profiles.find((profile) => profile.varname === event.target.value)
            if (prof) {
                onProfileChange(prof)
            }
        }
    }

    const canShowMenuLink = (resource: string) => {
        switch (resource) {
            case "reference_books":
                return profile?.varname === "administrator"
        }
        //const isResourceValid = resources[resource]?.options?.permissions
        return true
    }

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <Box flexGrow={1}>
                <Menu>
                    <Menu.DashboardItem />
                    {Object.keys(resources).map(resource => (
                        <ScreenEmpty key={resource} enabled={canShowMenuLink(resource)}>
                            <Menu.ResourceItem name={resource} />
                        </ScreenEmpty>
                    ))}

                    <Menu.Item
                        key="devices_ddt"
                        to="/devices-ddt"
                        leftIcon={<Sensors />}
                        primaryText={translate("resources.devices.ddt")}
                    />
                    <Menu.Item
                        key="objects_flow"
                        to="/objects/flow"
                        primaryText={translate("resources.objects.scheme_gts")}
                        leftIcon={<AccountTreeIcon />}
                    />
                    <Menu.Item
                        key="objects_map"
                        to="/objects/map"
                        leftIcon={<MapIcon />}
                        primaryText={translate("resources.objects.map")}
                    />
                    <ScreenEmpty enabled={canShowMenuLink("reference_books")}>
                        <ReferenceBooksItem/>
                    </ScreenEmpty>

                    {/* <Menu.Item
                        to="/settings"
                        primaryText="Settings"
                        leftIcon={<SettingsIcon />}
                    />
                    <Menu.Item
                        to="/profile"
                        primaryText="Profile"
                        leftIcon={<PersonIcon />}
                    /> */}
                </Menu>
            </Box>
            <Box p={2} sx={{ borderTop: '1px solid rgba(0, 0, 0, 0.12)' }}>
                <FormControl fullWidth size="small">
                    <ScreenEmpty enabled={menuOpen}>
                        <InputLabel id="bottom-select-label">{translate("resources.users.fields.current_profile")}</InputLabel>
                    </ScreenEmpty>
                    <Select
                        labelId="bottom-select-label"
                        label={menuOpen ? translate("resources.users.fields.current_profile") : undefined}
                        onChange={handleUpdateProfile}
                        defaultValue={profile?.varname}
                        key={profile?.varname}
                        sx={{
                            '& .MuiSelect-select': !menuOpen ? {
                                padding: '8px 8px 8px 6px !important',
                                display: 'flex',
                                alignItems: 'center',
                                '& .MuiListItemIcon-root': {
                                    minWidth: '24px',
                                }
                            } : {},
                            '& .MuiSelect-icon': !menuOpen ? {
                                display: 'none'
                            } : {}
                        }}
                    >
                        {user?.profiles.map((profile) => (
                            <MenuItem key={profile.id} value={profile.varname}>
                                <ScreenEmpty enabled={!menuOpen}>
                                    <ListItemIcon>
                                        <Tooltip title={profile.name} placement="right">
                                            <Box component="span">
                                                {profile.varname === "administrator" ? <AdminIcon /> : (profile.varname === "user" ? <PersonIcon /> : <TableIcon/>)}
                                            </Box>
                                        </Tooltip>
                                    </ListItemIcon>
                                </ScreenEmpty>
                                <ScreenEmpty enabled={menuOpen}>
                                    {profile.name}
                                </ScreenEmpty>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </Box>
    )
}

export default MainMenu
